import axios from "../axiosInstance";
import { CreateDraftInvoiceRequest, CreateDraftInvoiceResponse } from "./types";

export const createDraftInvoice = async (
  requestData: CreateDraftInvoiceRequest,
): Promise<CreateDraftInvoiceResponse> => {
  const response = await axios.post<CreateDraftInvoiceResponse>(
    "/api/private/stochastic/campaign-billing/draft-invoice",
    requestData,
  );
  return response.data;
};
